module.exports = __webpack_public_path__ + "img/actions-img.31a69342.svg";